import { render, staticRenderFns } from "./FrontPagination.vue?vue&type=template&id=0b0d5deb&scoped=true"
import script from "./FrontPagination.vue?vue&type=script&lang=js"
export * from "./FrontPagination.vue?vue&type=script&lang=js"
import style0 from "./FrontPagination.vue?vue&type=style&index=0&id=0b0d5deb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0d5deb",
  null
  
)

export default component.exports